import axios from 'axios'
import Vue from 'vue'
import i18n from '../../../../i18n';

const state = {
    token: localStorage.getItem('user-token') || '',
    loading: true,
    banners: [],
    banner: {},
    message: {},
}

const getters = {
    getAllBanners(state){
        return state.banners;
    },
    getBanner(state){
        return state.banner;
    },
}

const mutations = {
    updateAllBanners(state, banners) {
        state.banners = banners
     },
     updateBanner(state, banner) {
        state.banner = banner
     },
     updateBannerResponseMsg(state, message) {
        state.message = message
     },
}

const actions = {
    ['LOAD_ALL_BANNERS']: ({commit}) => {
        return new Promise((resolve) => { 
        axios.get('banner',
        {}).then(resp => {
            if(!resp.data.error){
                commit('updateAllBanners', resp.data.data)
            } else {
              console.log('Error')
            }
            resolve(resp)
            })
        })
    },

    ['CREATE_BANNER']: ({commit}, formData) => {
        return new Promise((resolve) => { 
        axios.post(`banner`, formData )
        .then(resp => {
            if(!resp.data.error){
                commit('updateBannerResponseMsg', resp.data)
                Vue.toasted.show(i18n.tc(`successfully`),{
                    theme: 'outline',
                    singleton: true,
                    position:'top-center',
                    action :
                    {
                        text : i18n.tc(`ok`),
                        onClick : (e, toastObject) => {
                            toastObject.goAway(0);
                        }  
                    }
                });
            } else {
              console.log(resp.data.error)
            }
            resolve(resp)
            })
        })
      },

      ['GET_BANNER']: ({commit}, id) => {
        return new Promise((resolve) => { 
        axios.get(`/banner/${id}`, 
        {}).then(resp => {
            if(!resp.data.error){
                commit('updateBanner', resp.data.data)
            } else {
              console.log(resp.data.error)
            }
            resolve(resp)
            })
        })
      },

      ['DELETE_BANNER']: ({commit}, id) => {
        return new Promise((resolve) => { 
        axios.delete(`/banner/${id}`, 
        {}).then(resp => {
            if(!resp.data.error){
                commit('updateBannerResponseMsg', resp.data.data)
                console.log(resp.data)
                Vue.toasted.show(i18n.tc(`successfully`),{
                    theme: 'outline',
                    singleton: true,
                    position:'top-center',
                    action :
                    {
                        text : i18n.tc(`ok`),
                        onClick : (e, toastObject) => {
                            toastObject.goAway(0);
                        }  
                    }
                });
            } else {
              console.log(resp.data.error)
            }
            resolve(resp)
            })
        })
      },

}

export default {
    state,
    getters,
    mutations,
    actions
}